import {
  FormVersionEditionsRequestParams,
  FormVersionEditionsRequestQuery,
  FormVersionEditionsSearchResponse,
} from '@lio/api-types';
import { formVersionQueryKeys } from '@services/formVersion/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

const getQuery = (params?: FormVersionEditionsRequestQuery) => {
  const { isAvailable, isVisible, includeConflicted } = params || {};
  const query = new URLSearchParams();

  if (isAvailable !== undefined) {
    query.append('isAvailable', String(isAvailable));
  }
  if (isVisible !== undefined) {
    query.append('isVisible', String(isVisible));
  }
  if (includeConflicted !== undefined) {
    query.append('includeConflicted', String(includeConflicted));
  }

  return query.toString();
};

export const useGetFormVersionEditions = (
  params: (FormVersionEditionsRequestParams & FormVersionEditionsRequestQuery) | { quoteId: undefined },
  options?: { enabled?: boolean },
) => {
  const client = useClient();

  const { quoteId, formVersionId, ...queryParams } = params as FormVersionEditionsRequestParams &
    FormVersionEditionsRequestQuery;

  const qs = getQuery(queryParams);

  const enabled = options?.enabled ?? true;

  const result = useQuery<FormVersionEditionsSearchResponse, Error>({
    queryKey: formVersionQueryKeys.editions(
      params as FormVersionEditionsRequestParams & FormVersionEditionsRequestQuery,
    ),
    queryFn: () =>
      client
        .get(`quote/${quoteId}/form-version/${formVersionId}/edition${qs ? `?${qs}` : ''}`)
        .json<FormVersionEditionsSearchResponse>(),
    enabled: !!quoteId && !!formVersionId && enabled,
    staleTime: 20000,
  });

  return { ...result, editions: result.data };
};
